export default __webpack_public_path__ + "static/media/Langs.c48e4ef7.svg";